import request from "@/utils/request";

// 查看岗位
export function search_job(data) {
    return request({
        url: "/search_job",
        method: "post",
        data: data,
    });
}
// 岗位详情
export function job_particulars(data) {
    return request({
        url: "/job_particulars",
        method: "post",
        data: data,
    });
}
// 添加岗位
export function add_job(data) {
    return request({
        url: "/add_job",
        method: "post",
        data: data,
    });
}
// 修改岗位
export function update_job(data) {
    return request({
        url: "/update_job",
        method: "post",
        data: data,
    });
}
// 删除岗位
export function delete_job(data) {
    return request({
        url: "/delete_job",
        method: "post",
        data: data,
    });
}
